import axios from 'axios'
import interceptors from './interceptors'
import { remediatorAPIServerURL } from '../../config'
import localforage from 'localforage'
import { isEmpty } from 'lodash'
import { userTokenStorageKey } from 'src/config'
// allow use http client without Vue instance

let finalURL = remediatorAPIServerURL;
// let type = localStorage.getItem('type');
// if(type == 1) {
//   finalURL += 'gsuite/';
// } else if (type == 2) {
//   finalURL += 'office/';
// } else if (type == 3) {
//   finalURL += 'outlook/';
// } else if (type == 4) {
//   finalURL += 'exchange/';
// }

export const http = axios.create({
  baseURL: finalURL,
})

/**
* Helper method to set the header with the token
*/
export function setToken(token) { 
  http.defaults.headers.common.Authorization = `Bearer ${token}`;
}

/**
* Helper method to update Base url
*/
export function updateBaseUrl(type) { 
  let finalURL = remediatorAPIServerURL;
  // if(type == 1) {
  //   finalURL += 'gsuite/';
  // } else if (type == 2) {
  //   finalURL += 'office/';
  // } else if (type == 3) {
  //   finalURL += 'outlook/';
  // } else if (type == 4) {
  //   finalURL += 'exchange/';
  // }
  http.defaults.baseURL = finalURL;
}

// receive store and data by options
// https://vuejs.org/v2/guide/plugins.html
export default function install(Vue, { store, router }) {
  let token = localStorage.getItem('emailRem-token'); 
  if(token) {
    setToken(token);
}

  // let type = localStorage.getItem('type');
  // if(type) {
  // updateBaseUrl(type);
  // }

  interceptors(http, store, router)
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
  Object.defineProperty(Vue.prototype, '$http', {
    get() {
      return http
    },
  })
}


export function showLoader() {
    $('.pace').removeClass('pace-inactive');
    $('.pace').addClass('pace-active');    
}

export function toggleLoader() {
    $('.pace').toggleClass('pace-inactive');
    $('.pace').toggleClass('pace-active');
}

export function hideLoader() {
    $('.pace').removeClass('pace-active');
    $('.pace').addClass('pace-inactive');
}



// WEBPACK FOOTER //
// ./src/plugins/http/index.js